export function userMention(name) {
  if (contains(name, ' ') || contains(name, '.') || contains(name, '@')) {
    return `@{${name}}`;
  }
  return '@' + name;
}

function contains(string, substring) {
  return string.indexOf(substring) > -1;
}
